module.exports = __webpack_public_path__ + "img/img25.819bd98d.jpg";